export default "__VITE_ASSET__ee9e4d59__"